import PropTypes from "prop-types";
import { useEffect, useLayoutEffect } from "react";
import Skeleton from "react-loading-skeleton";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";
import { useIncomeTaxRates } from "../api";

import "./income-tax-rates.dropdown.scss";

const getRegion = (regionIsoCode) => {
  return regionIsoCode?.split("-")[1];
};

export const IncomeTaxRatesDropdown = ({
  value,
  onChange,
  loading,
  regionAltCode,
  countryIsoCode = "US",
}) => {
  const { data: incomeTaxRates, isLoading: loadingStateTaxes } =
    useIncomeTaxRates({
      countryIsoCode,
    });

  const onOptionSelected = (value) => {
    onChange?.(value);
  };

  useLayoutEffect(() => {
    // Workaround to calculate the list size and position correctly
    // Reference: src/features/goals/components/goals.container.jsx
    setTimeout(() => window.dispatchEvent(new Event("resize")), 250);
  }, [incomeTaxRates]);

  useEffect(() => {
    if (regionAltCode && !value) {
      const incomeTaxRate = incomeTaxRates?.find(
        (v) => v.regionAltCode === regionAltCode,
      );
      incomeTaxRate && onChange?.(incomeTaxRate);
    }
  }, [regionAltCode, incomeTaxRates, value]);

  if (loadingStateTaxes || loading) {
    return <Skeleton width={"2.352rem"} height={"1.764rem"} />;
  }

  return (
    <Dropdown
      className="income-tax-rates-dropdown"
      selected={value}
      onOptionSelected={onOptionSelected}
    >
      <DropdownButton>{getRegion(value?.regionIsoCode)}</DropdownButton>
      <DropdownItems maxHeight={200}>
        {incomeTaxRates?.map((v) => (
          <DropdownItem
            key={v.regionIsoCode}
            value={v}
            propName="regionAltCode"
          >
            {`${v.regionName} (${getRegion(v.regionIsoCode)})`}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
};

IncomeTaxRatesDropdown.propTypes = {
  countryIsoCode: PropTypes.string,
  regionAltCode: PropTypes.string,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.shape({
    regionIsoCode: PropTypes.string,
    regionName: PropTypes.string,
    regionAltCode: PropTypes.string,
  }),
};
